<template>
    <s-modal 
        title="Créer une équipe simplifiée"
       
        :close="true"
        @close="$emit('close')"
        :save="false"
        :open="open"
    >
        <div>
            L'équipe que vous allez créer va créer des joueurs "invités"<br/>
            Si vous voulez créer des équipes à partir de vos membres, vous devez cliquer sur "Former une équipe"
        </div>
        <div class="itemInput">
        <s-input theme="is-primary"  v-model="name" placeholder="Nom de l'équipe"/>
        </div>
        <div class="itemInput">
            <s-input theme="is-danger"  v-model="J1" placeholder="Pseudo du joueur 1"/>
            <div class="error" v-if="error">
                Il faut au moins le pseudo du joueur 1
            </div>
        </div>
        <div class="itemInput">
            <s-input theme="is-primary"  v-model="J2" placeholder="Pseudo du joueur 2"/>
        </div>
       <div class="itemInput">
            <s-input theme="is-primary"  v-model="J3" placeholder="Pseudo du joueur 3"/>
        </div>
        <div>
            <div style="text-align:left;margin:5px">
                <s-button theme="is-warning" icon="save" label="Enregistrer et fermer" @onclick="save(false)"/>
            </div>
            <div style="text-align:right;margin:5px">
                <s-button theme="is-success" icon="plus" label="Enregistrer et ajouter" @onclick="save(true)"/>
            </div>
        </div>
    </s-modal>

</template>
<style scoped>
    .itemInput {
        margin: 5px;
    }
    .error {
        color: red;
        font-size: 12px;
        font-style: italic;
    }
</style>
<script>
import joueur_fct   from '@/firebase/joueur'
import tournoi_fct  from '@/firebase/tournoi'
const { v4: uuidv4 } = require('uuid');
export default {
    props: ['open', 'tournoi', 'club'],
    data() {
        return {
            name: "",
            J1: "",
            J2: "",
            J3: "",
            error: false
        }
    },
   
    methods: {
        save(newTeam) {
          
            if (this.J1=="")
                this.error = true;
            else {
                this.error = false;
               
                var meneur = JSON.parse(JSON.stringify(joueur_fct.object.data));
              
                meneur.nameEquipe = this.name;
                meneur.pseudo = this.J1;
                meneur.id = uuidv4();
               
                meneur.invite = true;
                meneur.meneur = true;
                if (typeof(this.tournoi.invites)=="undefined")
                    this.tournoi.invites = {}
                this.tournoi.invites[meneur.id] = JSON.parse(JSON.stringify(meneur))
               
                if (this.J2!="") {
                    var joueur = JSON.parse(JSON.stringify(joueur_fct.object.data));
                    joueur.pseudo = this.J2;
                    joueur.id = uuidv4();
                    joueur.invite = true;
                    joueur.meneur = false;
                    this.tournoi.invites[joueur.id] = JSON.parse(JSON.stringify(joueur))
                    meneur.coequipier1 = joueur.id;
                    this.tournoi.joueurs.push(JSON.parse(JSON.stringify(joueur)));
                }
                
                if (this.J3!="") {
                    var joueur = JSON.parse(JSON.stringify(joueur_fct.object.data));
                    joueur.pseudo = this.J3;
                    joueur.id = uuidv4();
                    joueur.invite = true;
                    joueur.meneur = false;
                    this.tournoi.invites[joueur.id] = JSON.parse(JSON.stringify(joueur));
                    meneur.coequipier2 = joueur.id;
                    this.tournoi.joueurs.push(JSON.parse(JSON.stringify(joueur)));
                }
               
               
                this.tournoi.joueurs.push(JSON.parse(JSON.stringify(meneur)));
                tournoi_fct.object.set(this.club, this.tournoi,()=>{
                    this.name = "";
                        this.J1 = "";
                        this.J2 = "";
                        this.J3 = "";
                        this.error = false;
                    if (!newTeam)                         
                        this.$emit("close");
                })
            }
        },

    }
}
</script>
